import { render, staticRenderFns } from "./CloudAdministration.vue?vue&type=template&id=bda19670&"
import script from "./CloudAdministration.vue?vue&type=script&lang=js&"
export * from "./CloudAdministration.vue?vue&type=script&lang=js&"
import style0 from "./CloudAdministration.vue?vue&type=style&index=0&id=bda19670&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports